"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.popupWindow = exports.windowObject = void 0;
const popupWindow = ({ url, failPopUp, pw = 414, ph = 539, windowInfo = null, }) => {
    const { top, left } = getPopupPosition(pw, ph, windowInfo);
    if (exports.windowObject && !exports.windowObject.closed) {
        exports.windowObject.location.href = url;
        exports.windowObject.focus();
    }
    else {
        exports.windowObject = window.open(url, 'pspProcessingPopup', `popup=true,width=${pw},height=${ph}},left=${left},top=${top}`);
        const loading = setTimeout(() => {
            // Browser has blocked it
            if (failPopUp) {
                failPopUp();
            }
        }, 8000);
        try {
            if (exports.windowObject) {
                exports.windowObject.addEventListener('load', () => clearTimeout(loading));
            }
        }
        catch (e) {
            clearTimeout(loading);
            if (failPopUp) {
                failPopUp();
            }
        }
    }
    return exports.windowObject;
};
exports.popupWindow = popupWindow;
const getPopupPosition = (width, height, windowInfo) => {
    console.log("windowInfo (top):", windowInfo);
    if (!windowInfo) {
        // Fallback to gpas window object, gpas is not iframed (no used since gpas is usually iframed)
        // This is a fallback for when the windowInfo is not provided
        const screenWidth = window.screen.width;
        const screenHeight = window.screen.height;
        const screenLeft = window.screenLeft || window.screenX;
        const screenTop = window.screenTop || window.screenY;
        return {
            left: screenLeft + (screenWidth - width) / 2,
            top: screenTop + (screenHeight - height) / 2,
        };
    }
    const { screenLeft, screenTop, windowHeight, windowWidth } = windowInfo;
    return {
        left: screenLeft + windowWidth / 2 - width / 2,
        top: screenTop + windowHeight / 2 - height / 2,
    };
};
